import * as React from 'react';
import { cn } from '@/lib/utils/cn';

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    rows={4}
    className={cn(
      'flex w-full rounded-lg border border-border bg-white px-4 py-3 text-sm text-ink shadow-sm transition-colors',
      'placeholder:text-muted',
      'focus-visible:border-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/30',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive/30',
      'resize-y',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';

export { Textarea };
